import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=f2b35612&scoped=true"
import script from "./addModel.vue?vue&type=script&lang=js"
export * from "./addModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b35612",
  null
  
)

export default component.exports